import {use, ZoneId, ZoneOffset, ZoneRegion} from "js-joda";
declare var require: any;
use(require('js-joda-timezone'));


export class Timezone {
  abbreviation: string;
  name: string;
  offset: string;

  get region() {
    return ZoneRegion.ofOffset("UTC", ZoneOffset.of(this.offset.slice(3)));
  }

  get zoneId() {
    return ZoneId.ofOffset("UTC", ZoneOffset.of(this.offset.slice(3)));
  }

  fill(obj) {
    this.abbreviation = obj.abbreviation;
    this.name = obj.name;
    this.offset = obj.offset;
    return this;
  }
}



// WEBPACK FOOTER //
// /app/src/app/Models/Timezone.ts